import PropTypes from "prop-types";
import { Ok } from "react-ikonate";
import styles from "./CircleCheckbox.module.css";

/**
 * Interactive component. A button that allows the user to reset their vote on a decision item.
 */
export function CircleCheckbox({ checked, onChange, readOnly = false }) {
  return (
    <>
      <div className={styles.container}>
        <input
          disabled={readOnly}
          type="checkbox"
          className={styles.checkbox}
          checked={checked}
          onChange={onChange}
        />
        <div className={styles.icon}>
          <Ok />
        </div>
      </div>
    </>
  );
}

CircleCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};
